import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function RankingSection() {
  const ranked = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 10);

  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-lg md:text-xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
              排行榜
            </h2>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">评分最高的<strong>热门漫画</strong></p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {ranked.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex items-center gap-4 p-3 md:p-4 rounded-lg bg-background-50 hover:bg-background-100 transition-colors cursor-pointer group"
            >
              <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                {index < 3 ? (
                  <span className={`text-sm font-bold ${index === 0 ? 'text-accent-500' : index === 1 ? 'text-secondary-500' : 'text-primary-400'}`}>
                    {index + 1}
                  </span>
                ) : (
                  <span className="text-sm font-medium text-foreground-400">{index + 1}</span>
                )}
              </div>

              <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 漫画排行榜`}
                  title={`${comic.title} - 43423漫画网排行榜`}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5 truncate">{comic.author} · {comic.status}</p>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-[10px] text-accent-500"></i>
                  </span>
                  {comic.rating}
                </span>
                <span className="text-xs text-foreground-400 hidden sm:inline">
                  {formatViews(comic.views)} 阅读
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}